document.addEventListener('DOMContentLoaded', function() {
  const scrollRevealEls = document.querySelectorAll('.scroll-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    scrollRevealEls.forEach(el => observer.observe(el));
  } else {
    scrollRevealEls.forEach(el => el.classList.add('is-visible'));
  }
});
